import axios from "axios"
const ROOT_PATH = "feature-flags"

export default class FeatureFlagsService {
	static getFeatureFlags = () => axios.get(ROOT_PATH)
}
